const VERTICAL_B2B = 'B2B';
const VERTICAL_CONSUMER = 'CONSUMER';

export { VERTICAL_B2B, VERTICAL_CONSUMER };
//# sourceMappingURL=Vertical.mjs.map
